var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWordCheck = function SvgWordCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828D99",
    fillRule: "evenodd",
    d: "M12.705 4.488a.793.793 0 0 0-.054-1.065.67.67 0 0 0-.992.059L8.504 7.264c-.64.767-1.07 1.28-1.438 1.612-.35.317-.557.386-.737.386s-.386-.07-.736-.386c-.368-.332-.799-.845-1.438-1.612L3.34 6.29a.67.67 0 0 0-.992-.06.793.793 0 0 0-.055 1.065l.849 1.018c.595.714 1.092 1.31 1.546 1.719.48.433.998.738 1.64.738.643 0 1.16-.305 1.64-.738.454-.41.951-1.005 1.547-1.72z",
    clipRule: "evenodd"
  })));
};
export { SvgWordCheck as ReactComponent };